import React from "react"

import ComplianceOverview from "@/components/compliance/ComplianceOverview"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { ComplianceFiltersProvider } from "@/contexts/ComplianceFiltersContext"

import ComplianceDataCompletenessTab from "./ComplianceDataCompletenessTab"
import LicenceChecksTab from "./LicenceChecksTab"

const ComplianceOverviewTab: React.FC = () => {
  return (
    <ComplianceFiltersProvider>
      <Tabs defaultValue="overview" className="w-full h-full">
        <TabsList className="mb-4">
          <TabsTrigger value="overview">Overview</TabsTrigger>
          <TabsTrigger value="licence-checks">Licence Checks</TabsTrigger>
          <TabsTrigger value="data-completeness">Data Completeness</TabsTrigger>
        </TabsList>
        <TabsContent value="overview">
          <ComplianceOverview />
        </TabsContent>
        <TabsContent value="licence-checks">
          <LicenceChecksTab />
        </TabsContent>
        <TabsContent value="data-completeness">
          <ComplianceDataCompletenessTab />
        </TabsContent>
      </Tabs>
    </ComplianceFiltersProvider>
  )
}

export default ComplianceOverviewTab
